import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-8 md:mb-12" }
const _hoisted_2 = { class: "mb-4 md:flex md:flex-row md:items-center md:justify-between" }
const _hoisted_3 = { class: "flex flex-col mb-4 md:flex-row md:w-1/2" }
const _hoisted_4 = { class: "flex flex-col mb-4 md:flex-row md:w-1/2" }
const _hoisted_5 = { class: "flex flex-row w-full md:justify-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-2xl" }, "-", -1)
const _hoisted_7 = { class: "flex flex-col lg:flex-row mb-4" }
const _hoisted_8 = { class: "flex flex-row w-full lg:w-1/2" }
const _hoisted_9 = { class: "w-1/2" }
const _hoisted_10 = { class: "w-1/2" }
const _hoisted_11 = { class: "flex flex-row w-full lg:w-1/2" }
const _hoisted_12 = { class: "w-1/2" }
const _hoisted_13 = { class: "w-1/2" }
const _hoisted_14 = { class: "w-1/2 text-center" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "mb-10 md:flex md:flex-row md:items-center md:justify-between" }
const _hoisted_17 = { class: "w-full mb-4 md:mb-0 md:w-3/5" }
const _hoisted_18 = { class: "flex flex-row items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-plus ml-2 text-medium mr-1" }, null, -1)
const _hoisted_20 = { class: "hidden md:flex flex-row md:text-center items-center justify-between text-light font-bold text-headings-gray mb-8 px-10" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "w-20" }, " ", -1)
const _hoisted_22 = { class: "flex flex-row flex-1" }
const _hoisted_23 = { class: "md:text-left w-1/6" }
const _hoisted_24 = { class: "w-1/6" }
const _hoisted_25 = { class: "w-1/6" }
const _hoisted_26 = { class: "w-1/6" }
const _hoisted_27 = { class: "w-1/6" }
const _hoisted_28 = { class: "w-1/6" }
const _hoisted_29 = { class: "w-1/6" }
const _hoisted_30 = { class: "w-20 flex flex-row justify-end" }
const _hoisted_31 = ["checked"]
const _hoisted_32 = {
  key: 0,
  class: "rounded bg-white p-6 md:px-4 flex flex-col md:items-center relative mb-5 md:flex-row justify-center font-bold text-medium"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { class: "mb-12 text-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_status_buttons = _resolveComponent("status-buttons")!
  const _component_datepicker_input = _resolveComponent("datepicker-input")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_search_input = _resolveComponent("search-input")!
  const _component_ActionButton = _resolveComponent("ActionButton")!
  const _component_default_button = _resolveComponent("default-button")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_parcel_list_item = _resolveComponent("parcel-list-item")!
  const _component_DynamicForm = _resolveComponent("DynamicForm")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("parcels.list.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_status_buttons, { onStatusUpdate: _ctx.statusUpdate }, null, 8, ["onStatusUpdate"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_datepicker_input, {
            class: "mr-5 md:w-1/4",
            placeholder: "filters.from_date",
            onDateUpdate: _ctx.dateFromUpdate
          }, null, 8, ["onDateUpdate"]),
          _hoisted_6,
          _createVNode(_component_datepicker_input, {
            class: "ml-5 md:w-1/4",
            placeholder: "filters.to_date",
            onDateUpdate: _ctx.dateToUpdate
          }, null, 8, ["onDateUpdate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_FormInput, {
            elementData: _ctx.filtersData.countries,
            values: _ctx.filtersValue,
            initialState: { value: _ctx.filtersValue.countries },
            onFormInputValueUpdate: _ctx.selectFilterUpdate
          }, null, 8, ["elementData", "values", "initialState", "onFormInputValueUpdate"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_FormInput, {
            elementData: _ctx.filtersData.suppliers,
            values: _ctx.filtersValue,
            initialState: { value: _ctx.filtersValue.suppliers },
            onFormInputValueUpdate: _ctx.selectFilterUpdate
          }, null, 8, ["elementData", "values", "initialState", "onFormInputValueUpdate"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_FormInput, {
            elementData: _ctx.filtersData.products,
            values: _ctx.filtersValue,
            initialState: { value: _ctx.filtersValue.products },
            onFormInputValueUpdate: _ctx.selectFilterUpdate
          }, null, 8, ["elementData", "values", "initialState", "onFormInputValueUpdate"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_FormInput, {
            elementData: _ctx.filtersData.integration_sources,
            values: _ctx.filtersValue,
            initialState: { value: _ctx.filtersValue.integration_sources },
            onFormInputValueUpdate: _ctx.selectFilterUpdate
          }, null, 8, ["elementData", "values", "initialState", "onFormInputValueUpdate"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", {
            class: "uppercase text-primary-blue px-5 mt-3",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearSelectFilters && _ctx.clearSelectFilters(...args)), ["stop"])),
            innerHTML: _ctx.$t('general.clear')
          }, null, 8, _hoisted_15)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_search_input, {
          placeholder: "parcels.list.filters.search",
          isLoading: _ctx.isLoading,
          onSearchUpdate: _ctx.searchUpdate,
          onSearchAction: _ctx.getList
        }, null, 8, ["isLoading", "onSearchUpdate", "onSearchAction"])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_ActionButton, {
          accountDetails: _ctx.accountDetails,
          parcelsIds: _ctx.checkedParcels,
          values: {
            country_ids: _ctx.filtersValue.countries.join(),
            supplier_ids: _ctx.filtersValue.suppliers.join(),
            product_ids: _ctx.filtersValue.products.join(),
            date_to: _ctx.dateTo,
            date_from: _ctx.dateFrom,
            status: _ctx.status,
            search: _ctx.search,
          }
        }, null, 8, ["accountDetails", "parcelsIds", "values"]),
        _createVNode(_component_default_button, {
          class: "w-full md:w-auto ml-4",
          onClick: _ctx.createNewParcel
        }, {
          default: _withCtx(() => [
            _hoisted_19,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("parcels.list.actions.create_shipment")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    (_ctx.pagination)
      ? (_openBlock(), _createBlock(_component_pagination, {
          key: 0,
          "total-rows": 20,
          meta: _ctx.pagination,
          onChangePagination: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePagination($event.page, $event.perPage)))
        }, null, 8, ["meta"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("parcels.list.item.labels.id")), 1),
          _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("parcels.list.item.labels.supplier")), 1),
          _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("parcels.list.item.labels.created_date")), 1),
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("parcels.list.item.labels.status")), 1),
          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t("parcels.list.item.labels.tracking_link")), 1),
          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t("parcels.list.item.labels.fm_tracking_link")), 1),
          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("parcels.list.item.labels.label")), 1)
        ]),
        _createElementVNode("div", _hoisted_30, [
          (!_ctx.isLoading)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 0,
                type: "checkbox",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.checkParcelsPage && _ctx.checkParcelsPage(...args))),
                checked: _ctx.isParcelsPageChecked,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isParcelsPageChecked) = $event))
              }, null, 40, _hoisted_31)), [
                [_vModelCheckbox, _ctx.isParcelsPageChecked]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_spinner, {
            key: 0,
            class: "mx-auto"
          }))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.parcels.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  (_ctx.loadFailed)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$t("general.list_load_error")), 1))
                    : (
              _ctx.searchedPhrase.length === 0 || _ctx.searchedPhrase.length >= 3
            )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.$t("general.empty_list")), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$t("general.empty_list_min_3_characters")), 1))
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parcels, (parcel) => {
              return (_openBlock(), _createBlock(_component_parcel_list_item, {
                key: parcel.id,
                parcel: parcel,
                accountDetails: _ctx.accountDetails,
                onCheckParcel: _ctx.checkParcel,
                onEditParcel: _ctx.editParcel,
                onCreateReturnParcel: _ctx.createNewReturnParcel,
                isChecked: _ctx.isParcelChecked(parcel?.id)
              }, null, 8, ["parcel", "accountDetails", "onCheckParcel", "onEditParcel", "onCreateReturnParcel", "isChecked"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.pagination)
      ? (_openBlock(), _createBlock(_component_pagination, {
          key: 1,
          "total-rows": 20,
          meta: _ctx.pagination,
          onChangePagination: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changePagination($event.page, $event.perPage)))
        }, null, 8, ["meta"]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      modelValue: _ctx.showParcelFormModal,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showParcelFormModal) = $event)),
      "hide-buttons": true
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t(_ctx.parcelFormTitle)), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DynamicForm, {
          formData: _ctx.parcelFormData,
          isLoading: _ctx.parcelFormLoading,
          isSaving: _ctx.parcelFormSaving,
          initValue: _ctx.parcelFormValue,
          initValidation: _ctx.parcelFormValidation,
          onCancelAction: _ctx.parcelFormCancelAction,
          onSubmitAction: _ctx.parcelFormSubmitAction
        }, null, 8, ["formData", "isLoading", "isSaving", "initValue", "initValidation", "onCancelAction", "onSubmitAction"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.showReturnParcelFormModal,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showReturnParcelFormModal) = $event)),
      "hide-buttons": true
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("return_parcels.create.title")), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DynamicForm, {
          formData: _ctx.returnParcelFormData,
          isLoading: _ctx.returnParcelFormLoading,
          isSaving: _ctx.returnParcelFormSaving,
          initValue: _ctx.returnParcelFormValue,
          initValidation: _ctx.returnParcelFormValidation,
          onCancelAction: _ctx.returnParcelCancelAction,
          onSubmitAction: _ctx.returnParcelSubmitAction
        }, null, 8, ["formData", "isLoading", "isSaving", "initValue", "initValidation", "onCancelAction", "onSubmitAction"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_modal, {
      modelValue: _ctx.showReturnParcelSuccessModal,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showReturnParcelSuccessModal) = $event)),
      "hide-cancel-button": true,
      "hide-confirm-button": true,
      size: "small"
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("return_parcels.create.success_title")), 1)
      ]),
      buttons: _withCtx(() => [
        _createVNode(_component_default_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (
            _ctx.$router.push({
              name: 'return_parcels.list',
              query: {
                search: `${_ctx.returnParcelSuccessId}`,
              },
            })
          ))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("return_parcels.create.success_button")), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t("return_parcels.create.success_description")), 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}